import script from "./FetchAllMixins.vue?vue&type=script&lang=ts"
export * from "./FetchAllMixins.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__